import type { ReactNode } from "react";
import { cx, radius as radiusVar, space, type RadiusToken, type SpaceToken } from "./tokens.ts";

export type SurfaceProps = {
  material?: "plain" | "elevated" | "glass";
  /** `dialog`: the fixed comfortable width of a centered card (same as a medium Sheet), shrinking on small screens. */
  width?: "dialog";
  padding?: SpaceToken;
  radius?: RadiusToken;
  testID?: string;
  children?: ReactNode;
};

/** `glass` = translucent + backdrop blur on web (Liquid Glass on iOS). Use for floating controls only. */
export function Surface({ material = "plain", width, padding, radius, testID, children }: SurfaceProps) {
  return (
    <div
      className={cx("b-surface", `b-surface-${material}`, width === "dialog" && "b-surface-dialog")}
      data-testid={testID}
      style={{ padding: padding === undefined ? undefined : space(padding), borderRadius: radius === undefined ? undefined : radiusVar(radius) }}
    >
      {children}
    </div>
  );
}
